document.addEventListener('DOMContentLoaded', function() {
    // Comprobar si desactivar_espias está activado en la configuración
    if (window.themeSettings && window.themeSettings.desactivar_espias) {
        // Deshabilitar clic derecho
        document.addEventListener('contextmenu', function(e) {
            e.preventDefault();
        });

        // Deshabilitar teclas específicas
        document.addEventListener('keydown', function(e) {
            // Deshabilitar F12 (tecla de desarrollo)
            if (e.key === "F12" || e.keyCode === 123) {
                e.preventDefault();
            }
            // Deshabilitar Ctrl+Shift+I (Inspector de elementos)
            if (e.ctrlKey && e.shiftKey && e.key === 'I') {
                e.preventDefault();
            }
            // Deshabilitar Ctrl+Shift+J (Consola de JavaScript)
            if (e.ctrlKey && e.shiftKey && e.key === 'J') {
                e.preventDefault();
            }
            // Deshabilitar Ctrl+U (Ver código fuente)
            if (e.ctrlKey && e.key === 'U') {
                e.preventDefault();
            }
        });
    }
});
